import { mapValues } from 'lodash';
import { Meta, Permissions } from '@ardoq/api-types';

/**
 * Asset meta resolved from other client state rather than from the asset
 * payload, which is why it is declared here and not on `Meta` in
 * `@ardoq/api-types`.
 */
export type ClientAssetMeta = {
  /**
   * The profile image of the org user `lastModifiedBy` points at, when that
   * user has one.
   */
  lastModifiedByImage?: string;
};

export type AssetWithClientMeta<T, E> = T & Meta<E> & { meta: ClientAssetMeta };

const enhanceAssetWithMeta = <T, E>(
  asset: T,
  assetType: E,
  mapMeta: (asset: T) => { permissions: Permissions },
  mapAsset: (asset: T) => any
): AssetWithClientMeta<T, E> => ({
  ...asset,
  ...mapAsset(asset),
  meta: { assetType, ...mapMeta(asset) },
});

export const enhanceWithMeta = <T, E>(
  assetsHash: { [id: string]: T },
  assetType: E,
  mapMeta: (asset: T) => { permissions: Permissions } = () => ({
    permissions: {},
  }),
  mapAsset: (asset: T) => any = () => ({})
): { [id: string]: AssetWithClientMeta<T, E> } =>
  mapValues({ ...assetsHash }, asset =>
    enhanceAssetWithMeta<T, E>(asset, assetType, mapMeta, mapAsset)
  );
